module.exports = __webpack_public_path__ + "static/media/Startup_Coaching.23c1c264.jpg";